import React, {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Layout} from 'antd';

import apiClient from 'utils/apiClient';

const {Content} = Layout;

interface SupportInfo {
    supportEmail?: string | null;
    supportPhone?: string | null;
}

const SupportContactsTab: React.FC = () => {
    const [supportInfo, setSupportInfo] = useState<SupportInfo>({});

    useEffect(() => {
        // Support contacts of the current user, resolved as customer -> managing organization -> default record
        const loadSupportInfo = async () => {
            try {
                const response = await apiClient.request('/api/v1/support-settings/current', [], 'GET');
                setSupportInfo({supportEmail: response?.supportEmail, supportPhone: response?.supportPhone});
            } catch (error) {
                console.error(error);
            }
        };

        loadSupportInfo();
    }, []);

    return (
        <>
            <hr className='form-group-separator'/>
            <Content className='support-content'>
                <div>
                    <div className='support-title'>
                        <FormattedMessage id='system.support_info'/>:
                    </div>
                    <div>
                        {supportInfo.supportEmail && (
                            <>
                                <span className='support-info-title'><FormattedMessage id='system.support_email'/>:</span> <span className='support-info'>{supportInfo.supportEmail}</span>
                                <br/>
                            </>
                        )}
                        {supportInfo.supportPhone && (
                            <>
                                <span className='support-info-title'><FormattedMessage id='system.support_phone'/>:</span> <span className='support-info'>{supportInfo.supportPhone}</span>
                            </>
                        )}
                    </div>
                </div>
            </Content>
        </>
    );
};

export default SupportContactsTab;
